import { WA_NUMBER, WA_MESSAGES } from '../../constants'

export default function TrekWhyUs({ trek }) {
  const cards = trek.whyUs || []
  if (!cards.length) return null

  const waMessage = WA_MESSAGES[trek.waKey] || WA_MESSAGES.general

  return (
    <section className="section bg-dark">
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <h2 className="section-title" style={{ color: 'white' }}>Why trek {trek.name} with us.</h2>
      </div>

      <div className="whyus-grid" style={{
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px', maxWidth: '1100px', margin: '0 auto',
      }}>
        {cards.map((c, i) => (
          <div
            key={c.n}
            className="whyus-card"
            style={{
              background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: '24px',
              transform: i % 2 === 1 ? 'translateY(28px)' : 'none',
            }}
          >
            <div style={{
              width: '32px', height: '32px', borderRadius: '50%', background: 'var(--green-light)',
              color: 'var(--green-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '12px', fontWeight: 700, marginBottom: '14px',
            }}>
              {c.n}
            </div>
            <div style={{ fontSize: '24px', marginBottom: '10px' }}>{c.icon}</div>
            <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '8px' }}>{c.title}</h3>
            <p style={{ fontSize: '12px', color: 'var(--ink-mid)', lineHeight: 1.6 }}>{c.text}</p>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '48px' }}>
        <a
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMessage)}`}
          target="_blank" rel="noreferrer"
          className="btn btn-primary"
          style={{ padding: '16px 32px', fontSize: '15px' }}
        >
          Message Us on WhatsApp
        </a>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .whyus-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .whyus-card { transform: none !important; }
        }
        @media (max-width: 520px) {
          .whyus-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  )
}
